let fault: Error | undefined;

export function getIsAnalyticsWorkerFaulted(): boolean {
    return !!fault;
}

export function setIsAnalyticsWorkerFaulted(e: Error | undefined): void {
    fault = e;
}
